import {GameStateEnums} from '../../../../../shared/GameEnums'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {UIGameMechanic} from '../UIGameEventController'
import {UIGameManager} from '../UIGameManager'
import {MechanicBarbarianInvasionState, MechanicKnightState} from '@colonist/game-states'

export class UIGameBarbarianInvasion implements UIGameMechanic {
    protected readonly uiGameManager: UIGameManager
    /**
     * @deprecated
     * This state is unused and will be removed in the future. It should not be removed yet because it forces the existence of the barbarian invasion mechanic to create a new UIWGameBarbarianInvasion class.
     */
    protected readonly barbarianInvasionState: MechanicBarbarianInvasionState
    protected readonly knightState: MechanicKnightState

    constructor(uiGameManager: UIGameManager, barbarianInvasionState: MechanicBarbarianInvasionState, knightState: MechanicKnightState) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)
        this.barbarianInvasionState = barbarianInvasionState
        this.knightState = knightState
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.MapStateUpdated:
            case UIGameEventEnums.KnightStateUpdated:
            case UIGameEventEnums.CanvasResized:
                this.onCanvasResize()
                break
            default: break
        }
    }

    // eslint-disable-next-line class-methods-use-this
    protected onCanvasResize() {
        return
    }
}
